import { render, staticRenderFns } from "./Navbar2.vue?vue&type=template&id=ab2b04f2&scoped=true"
import script from "./Navbar2.vue?vue&type=script&lang=js"
export * from "./Navbar2.vue?vue&type=script&lang=js"
import style0 from "./Navbar2.vue?vue&type=style&index=0&id=ab2b04f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2b04f2",
  null
  
)

export default component.exports